const actionPrefix = "@@alert"

export const PRESENT = `${actionPrefix}/PRESENT`
export const DISMISS = `${actionPrefix}/DISMISS`
